import { Column, Entity, PrimaryColumn, OneToMany } from "typeorm"
import { bigint } from "../../transofrmers/BigInt";
import { ContractTariff } from "./ContractTariff"

@Entity()
export class Tariff {
	
	@PrimaryColumn({unique: true})
	name!: string

	@Column()
	display_name!: string

  @Column({ type: "bigint", nullable:false, transformer:bigint })
	data_value!: number;

	@Column({default:true})
	include_in_flexi_tariff!: boolean

	@OneToMany(() => ContractTariff, contract => contract.tariff)
	contracts!: ContractTariff[]

	@Column({default:true})
  show_in_map!: boolean
}